import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        primary: {
            // light: will be calculated from palette.primary.main,
            main: "#533B41",
            // dark: will be calculated from palette.primary.main,
            // contrastText: will be calculated to contrast with palette.primary.main
        },
        secondary: {
            main: "#745258",
        },
    },
    shape: {
        borderRadius: 10,
    },
    typography: {
        fontFamily: "Roboto, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif",
        h1: {
            fontFamily: "Space Grotesk, Roboto, sans-serif",
        },
        h2: {
            fontFamily: "Space Grotesk, Roboto, sans-serif",
        },
        h3: {
            fontFamily: "Space Grotesk, Roboto, sans-serif",
        },
        h4: {
            fontFamily: "Space Grotesk, Roboto, sans-serif",
        },
        h5: {
            fontFamily: "Space Grotesk, Roboto, sans-serif",
        },
        h6: {
            fontFamily: "Space Grotesk, Roboto, sans-serif",
        },
    },
});

export default theme;